export function getDurationString(minutes: number) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const durationString = `${hours}:${
      remainingMinutes < 10 ? '0' : ''
    }${remainingMinutes}h`;

    return durationString;
}

export function getDurationStringHours(minutesReached: number, minutesTarget: number) {
    const hoursReached = Math.floor(minutesReached / 60);
    const hoursTarget = Math.floor(minutesTarget / 60);

    return `${hoursReached} / ${hoursTarget} h`;
}